import directives from './module';
import {masonryLib} from '../lazy_modules';
import {AnimatronProjects} from '../services/AnimatronProjectsSvc';
import {ExploreCtrl} from './ExplorePage';
import {Utils} from 'underscore-extensions';

class MasonryCtrl implements ng.IController {
    $onInit: () => void;
    anmSvcPromise: ng.IPromise<AnimatronProjects>;
    msnryPromise: ng.IPromise<any>;
    cache: Array<HTMLElement>;
    ExploreCtrl: ExploreCtrl;

    constructor($scope: ng.IScope,
                $rootScope: ng.IRootScopeService,
                $element: ng.IAugmentedJQuery,
                $q: angular.IQService) {
        this.$onInit = () => Utils.rAF(() => {
            const anmDefered = $q.defer();
            const destroy = $scope.$watch('animatron', a => {
                if (_.isObject(a)) {
                    anmDefered.resolve(a);
                    destroy();
                }
            });
            this.anmSvcPromise = anmDefered.promise;

            const container = $element[0];
            const columnWidth = container.querySelector('.projects-column-width').offsetWidth;
            const deferred = $q.defer();
            this.cache = [];
            loadScripts([masonryLib], () => {
                const Masonry = (window as any).Masonry;
                this.anmSvcPromise.then(a => a.computedWidth = columnWidth);
                const msnry = new Masonry(container, {
                    itemSelector: 'masonry-brick',
                    gutter: container.querySelector('.projects-gutter'),
                    columnWidth,
                    fitWidth: true,
                    containerStyle: null,
                    stagger: 30,
                    initLayout: true,
                    transitionDuration: (options.isIE ? '0' : '0.4s')
                });
                this.anmSvcPromise.then(a => a.nextPage());

                const destroyMsnry = () => {
                    msnry.items = [];
                    msnry.destroy();
                    msnry.layout();
                    msnry.bindResize();
                };

                $rootScope.$on('project:remove', (e, pid) => {
                    msnry.remove(document.getElementById('brick-' + pid));
                    msnry.layout();
                });
                $rootScope.$on('masonry:layout', () => msnry.layout());
                $rootScope.$on('masonry:destroy', () => destroyMsnry());

                if (this.ExploreCtrl) {
                    const onTabChangeFromCtrl = this.ExploreCtrl.onTabChange.bind(this.ExploreCtrl);
                    this.ExploreCtrl.onTabChange = args => {
                        destroyMsnry();
                        onTabChangeFromCtrl(args);
                    };
                }

                deferred.resolve(msnry);
            });
            this.msnryPromise = deferred.promise;
        });
    }
}

directives.directive('masonry', () => {
    return {
        scope: false,
        bindToController: true,
        require: {ExploreCtrl: '^?explorePage'},
        controller: MasonryCtrl
    };
});

directives.directive('masonryBrick', () => {
    return {
        require: '^masonry',
        scope: false,
        restrict: 'E',
        link(scope: ng.IRepeatScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, masonryCtrl: MasonryCtrl) {
            masonryCtrl.msnryPromise && masonryCtrl.msnryPromise.then(msnry => {
                element[0].classList.add('msnry-item');
                masonryCtrl.cache.push(element[0]);

                if (scope.$last) {
                    Utils.rAF(() => {
                        msnry.appended(masonryCtrl.cache);
                        msnry.reloadItems();
                        msnry.layout();
                        masonryCtrl.cache = [];
                        masonryCtrl.anmSvcPromise.then(a => a.busy = false);
                    });
                }
            });
        }
    };
});




// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/masonryDirectives.ts